import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, ElementRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessengerService, RoutingService } from '@web/birdz-angular';
import { CardEquippingComponent } from 'app/components/card-equipping/card-equipping.component';
import { CardRemoteReadingComponent } from 'app/components/card-remote-reading/card-remote-reading.component';
import { DashboardStats } from 'app/interfaces/dashboard-stats.interface';
import { Api } from 'app/services/api.service';
import { FilterService } from 'app/services/filter.service';
import { Observable, distinctUntilChanged, filter, finalize, map, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-page-dashboard-summary',
  templateUrl: './page-dashboard-summary.component.html',
  styleUrls: ['./page-dashboard-summary.component.scss'],
  imports: [CardEquippingComponent, CardRemoteReadingComponent, AsyncPipe],
})
export class PageDashboardSummaryComponent implements OnInit {
  private api = inject(Api);
  private filterService = inject(FilterService);
  private messenger = inject(MessengerService);
  private routing = inject(RoutingService);
  private ref = inject(ElementRef);
  private destroyRef = inject(DestroyRef);

  hasPerimeter$: Observable<boolean>;
  techno$: Observable<string | null>;
  stats: DashboardStats | null = null;
  isLoadingStats = 0;
  availableTechnos = ['watermetering'];

  constructor() {
    this.hasPerimeter$ = this.filterService.hasPerimeter$;
    this.techno$ = this.filterService.filter$.pipe(map((filters) => filters.techno));
  }

  ngOnInit() {
    this.fetchStatistics();
  }

  fetchStatistics() {
    this.filterService.filter$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        this.routing.pauseWhileDetached(this.ref, this.destroyRef),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
        tap(() => (this.stats = null)),
        filter(
          () =>
            this.filterService.hasPerimeter() && this.availableTechnos.includes(this.filterService.getTechno() ?? '')
        ),
        tap(() => this.isLoadingStats++),
        switchMap(() =>
          this.api.fetchDashboardStatistics(this.filterService.toParams()).pipe(
            takeUntilDestroyed(this.destroyRef),
            this.messenger.showFriendlyErrorMessage(),
            tap((stats) => (this.stats = stats)),
            finalize(() => this.isLoadingStats--)
          )
        )
      )
      .subscribe();
  }
}
